/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useAssessmentFees = () => {
  const [assessmentFeeNumbers, setAssessmentFeeNumbers] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const { token } = useAuthContext();

  const { reset } = useAbortController();

  const getAssessmentFees = useCallback(async () => {
    if (!token) {
      return;
    }

    setLoading(true);
    const url = 'live/master/fee/servicing/list';
    const formData = {
      assessmentFees: true,
    };

    const controller = reset();
    const config = { signal: controller.signal };

    const headers = {
      'Session-Token': token,
      'Content-Type': 'application/json',
    };

    try {
      let response = await axiosCall({ url: url, method: 'post', data: formData }, config, headers);
      console.log(response);
      setAssessmentFeeNumbers(response);
      setErrorMessage('');
      setLoading(false);
    } catch (error) {
      setErrorMessage('Error Loading Assessment Fees.');
      setLoading(false);
      console.error(error.message);
    }
  }, [reset, token]);

  useEffect(() => {
    getAssessmentFees();
  }, [getAssessmentFees]);

  return {
    assessmentFeeNumbers,
    loading,
    errorMessage,
  };
};

export default useAssessmentFees;
